import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class VisionFilterKeyCriteria extends BasicCriteria {
chronoCode: string;
visionCode: string;
}

